export default function ActivityIcon({ className = "", onClick = null }) {
  return (
    <svg
      className={className}
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 500 500"
    >
      <path d="M327.34,107.54c46.98,0,85.06,38.09,85.06,85.07,0,11.04-2.11,21.6-5.93,31.27-28.18,78.2-147.56,158.02-156.21,163.73l-.25.15-.25-.15c-8.65-5.71-128.02-85.53-156.21-163.73-3.82-9.67-5.93-20.23-5.93-31.27,0-46.98,38.08-85.07,85.06-85.07,34.32,0,63.89,20.33,77.34,49.6,13.45-29.26,43.01-49.6,77.34-49.6M327.34,79.93c-21.97,0-43.28,6.34-61.61,18.33-5.63,3.68-10.89,7.83-15.73,12.4-4.84-4.57-10.1-8.72-15.73-12.4-18.33-11.99-39.63-18.33-61.61-18.33-62.12,0-112.66,50.55-112.66,112.67,0,14.13,2.59,27.93,7.71,41.02,13.44,36.97,44.72,77.34,92.98,119.99,35.23,31.13,67.7,52.97,73.85,57.03l.43.28.44.27.25.15,14.35,8.73,14.35-8.73.25-.15.44-.27.43-.28c6.15-4.06,38.62-25.9,73.85-57.03,48.26-42.65,79.54-83.01,92.98-119.99,5.11-13.09,7.71-26.89,7.71-41.02,0-62.13-50.54-112.67-112.66-112.67h0Z"/>
    </svg>
  );
}
